import { render, staticRenderFns } from "./GFormWrapper.vue?vue&type=template&id=4ec3f6a2&"
import script from "./GFormWrapper.vue?vue&type=script&lang=ts&"
export * from "./GFormWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports